module.exports = __webpack_public_path__ + "static/media/swedish-massage.58962c05.svg";